<template>
   <div class="verAddCon"  v-if='showModel'>
        <div class="title">{{title}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem :label="$t('appPlan.titleName.appId')" prop="appId"  style="width: 500px" class="ivu-form-item-required">
                <SearchSelect ref="fwaresRef" :needName="$t('appPlan.needappId')"  :url="fwaresListUrl" labelName='id' isMultiple='2'  valName='id' keyword="id" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'appId')"></SearchSelect>
            </FormItem>

            <FormItem :label="$t('appPlan.titleName.version')" prop="version" style="width: 500px">
                <Input type="text" v-model.trim="formData.version" disabled :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('appPlan.titleName.releaseType')" prop="releaseType" style="width: 500px">
                <Input type="text" v-model.trim="formData.releaseTypeText" disabled :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('appPlan.titleName.appStatus')" prop="appStatus" style="width: 500px">
                <Input type="text" v-model.trim="formData.appStatusText" disabled :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

            <FormItem :label="$t('appPlan.titleName.os')" prop="os" style="width: 500px">
                <Input type="text" v-model.trim="formData.osText" disabled :placeholder="$t('inputPlaceholder')" ></Input>
            </FormItem>

             <FormItem :label="$t('appPlan.titleName.deviceGroupName')" prop="releaseGroup"  style="width: 500px" class="ivu-form-item-required">
                <SearchSelect ref="releaseGroupsRef" :needName="$t('appPlan.titleName.deviceGroupName')" :addAll='addAll'  :url="releaseGroupsListUrl" labelName='groupName' isMultiple='2'  valName='id' keyword="groupName" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectVal($event,'releaseGroup')"></SearchSelect>
            </FormItem>
            
            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
          
        </Form>

    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import SearchSelect from '../../common/selectList.vue'; //20220415
import { mapState } from 'vuex'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            offModel: Boolean
        },
        name: "ModelPlan",
        components: {
            SearchSelect
        },
        data() {
            return {   
                fwaresListUrl:this.config.urlArray.apps,
                releaseGroupsListUrl:this.config.urlArray.userGroups,
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                addAll:'firmwarePlan.allGroup',
                releaseGroupName:'',
                formData: {//表单数据
                    appId:'',
                    version: '',
                    releaseType:'',//1测试版 ，2 正式版
                    releaseTypeText:"",
                    appStatus:'',//1在使用 ，2 已过期
                    appStatusText:'',
                    os:'',//1安卓 ，2 苹果
                    osText:'',
                    releaseGroup:'',
                    releaseForAll:false
                }, 
               
            }
        },
        watch:{
            showModel(val){
                if(val === true) {   
                    this.$nextTick(()=>{//select赋值
                        this.$refs.fwaresRef.setQuery(null)
                        this.$refs.releaseGroupsRef.setQuery(null)
                    }); 
                    if(this.type==1){//新增
                        this.title = this.$t('appPlan.addButton')
                    }else if(this.type==2){

                        // console.log('this.editFormData',this.editFormData)
                        this.title = this.$t('appPlan.editButton')
                        for (let key in this.editFormData) {
                            if (this.formData.hasOwnProperty(key)) {
                                this.formData[key] = this.editFormData[key]
                            }
                        }

                        this.formData.appId = this.editFormData.appId + ''
                        this.formData.releaseGroup = this.editFormData.releaseGroup + ''

                        let obj = {'1':'android','2':'ios'}
                        this.formData.osText = obj[this.formData.os]
                        let obj1 = {'1':this.$t('selectList.releaseTypeList.beta'),'2':this.$t('selectList.releaseTypeList.release')}
                        this.formData.releaseTypeText = obj1[this.formData.releaseType]
                        let obj2 = {'1':this.$t('selectList.appStatusList.Online'),'2':this.$t('selectList.appStatusList.Expired')}
                        this.formData.appStatusText = obj2[this.formData.appStatus]


                        this.releaseGroupName = this.editFormData.releaseForAll?this.editFormData.releaseForAll:this.editFormData.releaseGroup

                        // console.log('this.releaseGroupName',this.editFormData)
                        // console.log('this.releaseGroupName',this.releaseGroupName)
                        if(this.formData.releaseForAll){//所有组
                           this.formData.releaseGroup = '0'
                        }
                         this.$nextTick(()=>{//select赋值
                            this.$refs.fwaresRef.setDefVal(Number(this.formData.appId));

                            if(this.formData.releaseForAll){
                                this.$refs.releaseGroupsRef.setDefVal(this.formData.releaseGroup)
                            }else{
                                this.$refs.releaseGroupsRef.setDefVal(Number(this.formData.releaseGroup))
                            }
                        }); 
                        // console.log(this.formData)
                    }
                  
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                     this.$refs.fwaresRef.clearVal();
                     this.$refs.releaseGroupsRef.clearVal();
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                    appId: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    releaseGroup: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ]
                    
                }
             } 

        },
        created(){
           
        },
        methods: {
            setSelectVal(e,key){
                this.formData[key] = e.nameVal+''
                if(key=='releaseGroup'){
                    this.releaseGroupName = e.nowData.label
                }
                if(key=='appId'){
                     this.formData.version = e.selItem.version
                     let obj = {'1':'android','2':'ios'}
                     this.formData.osText = obj[e.selItem.os]
                     let obj1 = {'1':this.$t('selectList.releaseTypeList.beta'),'2':this.$t('selectList.releaseTypeList.release')}
                     this.formData.releaseTypeText = obj1[e.selItem.releaseType]
                     let obj2 = {'1':this.$t('selectList.appStatusList.Online'),'2':this.$t('selectList.appStatusList.Expired')}
                     this.formData.appStatusText = obj2[e.selItem.status]
                }
            },
            subData(name) {//提交表单
                
                this.$refs[name].validate((valid) => {
                    if (valid) {
                       
                        this.disabled = true;
                        let url = ''

                        let dataObj = {
                            ...this.formData
                        }

                        if(this.type==2){//编辑
                            dataObj.id = this.editFormData.id
                            url = this.config.urlArray.appPlansEdit
                        }else{
                            url = this.config.urlArray.appPlansAdd
                        }
     
                        if(this.formData.releaseGroup==0 && this.releaseGroupName){
                            dataObj.releaseForAll = true
                            dataObj.releaseGroup = ""
                        }else{
                            dataObj.releaseGroup = this.formData.releaseGroup
                            dataObj.releaseForAll = false
                        }

                        if(this.formData.releaseTypeText== this.$t('selectList.releaseTypeList.beta')){
                            dataObj.releaseType = 1
                        }else{
                            dataObj.releaseType = 2
                        }

                        if(this.formData.appStatusText==this.$t('selectList.appStatusList.Online')){
                            dataObj.appStatus = 1
                        }else{
                            dataObj.appStatus = 2
                        }


                        if(this.formData.osText=='android'){
                            dataObj.osText = 1
                        }else{
                            dataObj.osText = 2
                        }


                        this.axios.post(url,{...dataObj,dealerId:this.selectId}).then((result) => {
                            
                            common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                                this.resetForm();//重置表单
                                this.fn()
                            },()=>{this.disabled = false})
                        
                        }).catch((err) => {
                            console.log(err)
                            // common.msg('error','提交失败',()=>{this.disabled = false;})
                            // this.disabled = false
                        });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);

                this.releaseGroupName = ''
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.releaseForAll = false
                if(this.type==2){
                    delete this.formData.id
                }
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .title{
        font-size: 20px;
        padding: 4px 0 20px;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
}
</style>
